/* Opens the cart DRAWER when a /cart redirect lands on a page with ?cart=open.
   Lives in an EXTERNAL asset (not an inline <script>) so the site's speed/perf tool
   doesn't strip it on the homepage. Same-origin only; does NOT modify the drawer or
   gift engine — it just calls the drawer's public open(). */
(function () {
  try {
    if (new URLSearchParams(window.location.search).get('cart') !== 'open') return;
    var opened = false;
    var openIt = function () {
      if (opened) return;
      var cd = document.querySelector('cart-drawer');
      if (cd && typeof cd.open === 'function') { opened = true; cd.open(); }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openIt);
    else openIt();
    setTimeout(openIt, 300);   // retry in case cart-drawer.js upgrades the element slightly later
    if (window.history && history.replaceState) history.replaceState({}, document.title, window.location.pathname);
  } catch (e) {}
})();
